import { render, staticRenderFns } from "./SelectFrom.vue?vue&type=template&id=5978e1b0&"
import script from "./SelectFrom.vue?vue&type=script&lang=js&"
export * from "./SelectFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports